/* eslint-disable */
import { translate, fetchGet } from '../backend/backend.service';
import * as endpoints from '../backend/backend.config';
import i18n from '../../i18n';
import { defaultLang } from "../../constants/default";

export async function getLanguages() {
    const response = await fetchGet(`${endpoints.LANGUAGES}`);
    return response;
}
export async function pageTranslation(data: any) {
    var resData = await translate(data)
    const propertyNames = Object.entries(resData);
    return resData
}

export async function getTranslationValues() {
    // @ts-ignore
    var transKeys = Object.keys(JSON.parse(JSON.stringify(i18n.global.messages.value[i18n.global.locale.value])))
    if (transKeys === undefined || transKeys.length == 0) {
        //throw new TypeError("Error getting current translation keys")
        //console.log("Error getting current translation keys");
        return
    }
    return transKeys
}

export async function loadMessages(data: Array<string>)
{
  try {
    // Check if data is not empty
    if (!data || data.length === 0 ) {
      // @ts-ignore
      if (process.env.NODE_ENV !== 'production') {
        console.error("No translations Ids or no language id")
      }
      return
    }

    const locale = localStorage.getItem("lang") ?? defaultLang
    var languageId

    if (localStorage.getItem("regionLanguages")) {
      //@ts-ignore
      languageId = JSON.parse(localStorage.getItem("regionLanguages"))[locale][1]
    }
    let translateAgain = false;
    let neededToBeTranslated: unknown[] = [];
    var translations = await pageTranslation({ 'locale': locale, 'data': data, 'languageId': languageId });
    Object.entries(translations).forEach(element => {
      const [key, value] = element;
      if(key == value && value != "\u0000" && value != "n\/a" && value != "") {
        translateAgain = true;
        neededToBeTranslated.push(value);
      }
    });
    if(translateAgain) {
      var extraTranslations = await pageTranslation({ 'locale': locale, 'data': neededToBeTranslated, 'languageId': languageId });
      translations = {
        ...translations,
        ...extraTranslations
    };
    }
    // @ts-ignore
    i18n.global.locale.value = locale
    // @ts-ignore
    i18n.global.mergeLocaleMessage(locale, translations)
  } catch (error) {
    // @ts-ignore
      if (process.env.NODE_ENV !== 'production') {
        console.error("An error occured during loading of translation, ", [error, data])
      }
    }
}